import React from 'react';
import { Link } from 'react-router-dom';
import { SERVICES_DATA } from '../../data/navigation';
import s from './ServicesGrid.module.css';

export default function ServicesGrid({ limit }) {
  const items = limit ? SERVICES_DATA.slice(0, limit) : SERVICES_DATA;
  return (
    <section className={`section ${s.section}`} id="services">
      <div className="container">
        <div className={`${s.header} reveal`}>
          <div>
            <p className="eyebrow">What We Offer</p>
            <h2 className="display-heading">All Your Dental Needs,<br/><em>Covered</em></h2>
          </div>
          <Link to="/book-appointment" className="btn btn-primary">Book a Consultation</Link>
        </div>
        <div className={s.grid}>
          {items.map((svc, i) => (
            <div key={svc.slug} className={`${s.card} ${svc.featured ? s.featured : ''} reveal reveal-delay-${i % 4}`}>
              <div className={s.num}>{svc.num}</div>
              <div className={s.icon}>{svc.icon}</div>
              <h3>{svc.title}</h3>
              <p>{svc.excerpt}</p>
              <Link to={`/services/${svc.slug}`} className={s.link}>Learn more →</Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
